import { FormlyFieldConfig } from '@ngx-formly/core';

export const optionsInputForm: FormlyFieldConfig[] = [
  {
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        key: '',
        className: 'form-wrapper--fieldset',
        wrappers: ['fieldset'],
        props: {
          translate: true,
          label: 'formGenerator.uiElement.optionsProp.titleFieldset',
        },

        fieldGroup: [
          {
            key: 'props.options',
            className: 'form-wrapper--row',
            type: 'fields-array',
            fieldArray: {
              fieldGroup: [
                {
                  wrappers: ['row'],
                  className: 'form-wrapper--row',
                  fieldGroup: [
                    {
                      key: 'id',
                      type: 'input',
                      props: {
                        translate: true,
                        label: 'formGenerator.uiElement.optionsProp.id.label',
                      },
                    },
                    {
                      key: 'name',
                      type: 'input',
                      props: {
                        translate: true,
                        label: 'formGenerator.uiElement.optionsProp.name.label',
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
